
// ServicePerformance.jsx
import React from 'react';
import { Icon } from '@iconify/react/dist/iconify.js';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const ServicePerformance = ({ services, formatCurrency }) => {
    // Format data for the chart
    const chartData = services.map(service => ({
        name: service.name,
        revenue: service.revenue,
        revenue: service.revenue,
        count: service.count
    }));

    return (
        <div className="card border-0 shadow-sm h-100">
            <div className="card-header bg-white border-bottom-0 pt-4 pb-0">
                <h5 className="mb-0">Top Services</h5>
            </div>
            <div className="card-body">
                <div style={{ height: '250px' }}>
                    <ResponsiveContainer width="100%" height="100%">
                        <BarChart
                            data={chartData}
                            margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                        >
                            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                            <XAxis dataKey="name" tick={{ fill: '#666' }} />
                            <YAxis tick={{ fill: '#666' }} />
                            <Tooltip
                                formatter={(value, name) => [
                                    name === 'revenue' ? formatCurrency(value) : value,
                                    name === 'revenue' ? 'Revenue' : 'Bookings'
                                ]}
                            />
                            <Bar dataKey="revenue" name="Revenue" fill="#8884d8" />
                        </BarChart>
                    </ResponsiveContainer>
                </div>
                
                <div className="mt-3">
                    <table className="table table-sm">
                        <thead>
                            <tr>
                                <th>Service</th>
                                <th className="text-end">Bookings</th>
                                <th className="text-end">Revenue</th>
                            </tr>
                        </thead>
                        <tbody>
                            {services.map((service, index) => (
                                <tr key={index}>
                                    <td>{service.name}</td>
                                    <td className="text-end">{service.count}</td>
                                    <td className="text-end">{formatCurrency(service.revenue)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default ServicePerformance;